import * as React from "react";
import { connect } from "react-redux";
import { Action, Dispatch } from "redux";
import { Field, InjectedFormProps, reduxForm } from "redux-form";
import styled from "styled-components";
import { customerConfig } from "../../../../config/language/ja-JP/domain/model_text";
import { ConstBreakPoint } from "../../../../config/styles_const/styles_const";
import { OuterURL } from "../../../../config/view_const/outer_url";
import { Gender } from "../../../../domain/model/customer";
import * as Validator from "../../../../util/validation";
import BtnCorporateLarge from "../../../common/atom/btn/btn_corporate_large";
import OuterLink from "../../../common/atom/outer_link";
import ErrorText from "../../../common/atom/text/error_text";
import DatepickerWrapper from "../../../common/atom/wrapper/datepicker_wrapper/datepicker_wrapper";
import FormFieldWrapper from "../../../common/atom/wrapper/form_field_wrapper";
import SubmitButtonWrapper from "../../../common/atom/wrapper/submit_btn_wrapper/submit_btn_wrapper";
import SubmitErrorTextWrapper from "../../../common/atom/wrapper/submit_error_text_wrapper";
import FormGroupCheckboxConnectRf from "../../../common/molecular/form_group/form_group_checkbox_connect_rf";
import FormGroupInputConnectRf from "../../../common/molecular/form_group/form_group_input_connect_rf";
import FormGroupSelectConnectRf from "../../../common/molecular/form_group/form_group_select_connect_rf";
import { AppState } from "../../../store/app_state";

const validate = (values: any) => {
  const errors: any = {};
  return errors;
};

interface IProps extends InjectedFormProps<FormData, {}> {}

interface IState {}

export class AuthProCreateForm extends React.Component<IProps, IState> {
  constructor(props: IProps) {
    super(props);

    this.state = {};
  }

  public render(): JSX.Element {
    const { anyTouched, invalid, handleSubmit, pristine, submitting } =
      this.props;

    const labelText = (
      <React.Fragment>
        <OuterLink href={`${OuterURL.termURL}`} target="_blank" rel="noopener">
          利用規約
        </OuterLink>
        と
        <OuterLink
          href={`${OuterURL.privacyURL}`}
          target="_blank"
          rel="noopener"
        >
          プライバシーポリシー
        </OuterLink>
        に同意します。
      </React.Fragment>
    );

    return (
      <Wrapper>
        <form name="ProCreateForm" onSubmit={handleSubmit}>
          <FormFieldWrapper>
            <Field
              label="メールアドレス"
              placeholder="メールアドレス"
              name="email"
              component={FormGroupInputConnectRf}
              type="text"
              validate={[
                Validator.email,
                Validator.emailCount,
                Validator.required,
              ]}
              require={true}
            />
          </FormFieldWrapper>
          <FormFieldWrapper>
            <Field
              label="パスワード"
              placeholder="パスワード"
              name="password"
              component={FormGroupInputConnectRf}
              type="password"
              validate={[
                Validator.password,
                Validator.passwordCount,
                Validator.required,
              ]}
              require={true}
            />
          </FormFieldWrapper>
          <FormFieldWrapper>
            <Field
              label={customerConfig.name}
              placeholder="山田　太郎"
              name="name"
              component={FormGroupInputConnectRf}
              type="text"
              validate={[Validator.customerName, Validator.required]}
              require={true}
            />
          </FormFieldWrapper>
          <FormFieldWrapper>
            <Field
              label={customerConfig.nameKana}
              placeholder="やまだ　たろう"
              name="nameKana"
              component={FormGroupInputConnectRf}
              type="text"
              validate={[Validator.customerNameKana, Validator.required]}
              require={true}
            />
          </FormFieldWrapper>
          <FormFieldWrapper>
            <Field
              label={customerConfig.phoneNumber}
              placeholder="080xxxxxxxx（ハイフンなし）"
              name="phoneNumber"
              component={FormGroupInputConnectRf}
              type="tell"
              validate={[Validator.phoneNumber, Validator.required]}
              require={true}
            />
          </FormFieldWrapper>
          <FormFieldWrapper>
            <Field
              label={customerConfig.gender}
              name="gender"
              component={FormGroupSelectConnectRf}
              type="text"
              validate={[Validator.required]}
              require={true}
            >
              <option disabled={true} />
              <option value={Gender.Gender_Male} key={Gender.Gender_Male}>
                {customerConfig.genderList.get(Gender.Gender_Male)}
              </option>
              <option value={Gender.Gender_Female} key={Gender.Gender_Female}>
                {customerConfig.genderList.get(Gender.Gender_Female)}
              </option>
              <option value={Gender.Gender_Unknown} key={Gender.Gender_Unknown}>
                {customerConfig.genderList.get(Gender.Gender_Unknown)}
              </option>
            </Field>
          </FormFieldWrapper>
          <FormFieldWrapper>
            <Field
              label="ポートフォリオ"
              placeholder="GitHubなどのポートフォリオリンク（任意です）"
              name="portfolio"
              component={FormGroupInputConnectRf}
              type="text"
              required={false}
            />
          </FormFieldWrapper>
          <FormFieldWrapper>
            <Field
              label={labelText}
              name="privacy"
              component={FormGroupCheckboxConnectRf}
              validate={[Validator.privacy]}
            />
          </FormFieldWrapper>

          {anyTouched && invalid && (
            <SubmitErrorTextWrapper>
              <ErrorText>入力を完了してください</ErrorText>
            </SubmitErrorTextWrapper>
          )}

          <SubmitButtonWrapper>
            <BtnCorporateLarge
              name="ProCreateForm-submit"
              type="submit"
              widthSize="200px"
              disabled={pristine || submitting || invalid}
            >
              登録する
            </BtnCorporateLarge>
          </SubmitButtonWrapper>
        </form>
      </Wrapper>
    );
  }
}

const mapStateToProps = (state: AppState) => {
  return {};
};

const mapDispatchToProps = (dispatch: Dispatch<Action>) => {
  return {};
};

export default reduxForm({
  form: "ProCreateForm",
  validate,
})(connect(mapStateToProps, mapDispatchToProps)(AuthProCreateForm));

const Wrapper = styled.div`
  @media screen and (min-width: ${ConstBreakPoint.Default}) {
    width: 400px;
  }
`;

const CustomDatepickerWrapper = styled(DatepickerWrapper)`
  flex-wrap: nowrap;
`;

const YearMonthDaysWrapper = styled.div`
  margin-right: 10px;
  flex: 1;

  &:last-child {
    margin-right: 0px;
  }
`;

const YearWrapper = styled(YearMonthDaysWrapper)`
  flex: 2;
`;



// WEBPACK FOOTER //
// ./src/presentation/component/auth/pro_create/auth_pro_create_form.tsx